import { MainContainer } from 'components/page/containers/MainContainer'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useOnboarding } from 'pages/onboarding/hooks/useOnboarding'
import { StyledEditProfileWrapper } from 'pages/profile/styled'
import React, { useState } from 'react'
import EditProfileDrawer from './EditProfileDrawer'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import EditProfileBio from './EditProfileBio'
import { useEditProfile } from 'pages/profile/hooks/useEditProfile'
import { onboardingStoreState } from 'models/onboarding/onboarding.store'
import { observer } from 'mobx-react'
import { AddResume2 } from './AddResume2'
import { useProfilePercentage } from 'hooks/use-profile-percentage/useProfilePercentage'
import { useDisappearingContainer } from 'hooks/use-disappearing-container/useDisappearingContainer'
import { CircleProfileCompletionBar } from 'components/page/profile-status/CircleProfileCompletionBar'
import { Box } from '@material-ui/core'
import CareerSummary from './CareerSummary'
import EditMainGoals from './EditMainGoals'
import { AccountSettingsGroupItemName } from 'common/types/account-settings-drawer.types'

const EditProfileSettingsPage = () => {
  const { backendUser } = useAuth()
  const { isDevice } = useScreenSizes()
  const { inviteUsersByEmail } = useOnboarding()
  const { resumeCompletion, willContainerDisappear , getBioCompletionPercentage, getCareerCompletionPercentage, goalsCompletion} = useProfilePercentage()
  const { isContainerVisible, setIsContainerVisible } = useDisappearingContainer(3000)

  const [editPageNumber, setEditPageNumber] = useState(1)

  const { editProfileQuestions, setEditProfileQuestions } = onboardingStoreState

  const groupBy = (items: any[], key: any) =>
    items?.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item].sort((a, b) => a.pageOrder - b.pageOrder)
      }),
      {}
    )

  const pages = groupBy(editProfileQuestions, 'page')

  const parentItems = [
    {
      name: 'Personal Bio',
      children: [
        <EditProfileBio
          user={backendUser}
          setProfileQuestions={setEditProfileQuestions}
        />
      ],
      endAdornment: (
        <Box visibility={willContainerDisappear('bio', backendUser, isContainerVisible) ? 'visible' : 'hidden'}>
          <CircleProfileCompletionBar progress={getBioCompletionPercentage(backendUser)} />
        </Box>
      )
    },
    {
      name: 'Career Summary',
      children: [<CareerSummary />],
      endAdornment: (
        <Box visibility={willContainerDisappear('career', backendUser, isContainerVisible) ? 'visible' : 'hidden'}>
          <CircleProfileCompletionBar progress={getCareerCompletionPercentage(backendUser)} />
        </Box>
      )
    },
    {
      name: 'Upload Resume',
      children: [<AddResume2 setIsContainerVisible={setIsContainerVisible} />],
      endAdornment: (
        <Box visibility={willContainerDisappear('resume', backendUser, isContainerVisible) ? 'visible' : 'hidden'}>
          <CircleProfileCompletionBar progress={resumeCompletion(backendUser)} />
        </Box>
      )
    },
    {
      name: 'Main goal(s) for joining Obsidi',
      children: [<EditMainGoals />],
      endAdornment: (
        <Box visibility={willContainerDisappear('goals', backendUser, isContainerVisible) ? 'visible' : 'hidden'}>
          <CircleProfileCompletionBar progress={goalsCompletion(backendUser)} />
        </Box>
      )
    }
  ]
  return (
    <MainContainer
      inviteUsersByEmail={inviteUsersByEmail}
      stickTopBar
      stickyFooter
      title={`Welcome ${backendUser?.firstName} ${backendUser?.lastName}`}
      user={backendUser}
      showAvatar
    >
      <StyledEditProfileWrapper isDevice={isDevice}>
        <EditProfileDrawer title={AccountSettingsGroupItemName.EDIT_PROFILE} parentItems={parentItems} />
      </StyledEditProfileWrapper>
    </MainContainer>
  )
}

export default observer(EditProfileSettingsPage)
